import Turnstile from "react-turnstile";

export default function TurnstileWidget({onVerify, className, error}) {
  return (
    <>
        <Turnstile
          sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
          onVerify={onVerify}
          theme={"light"}
          size={"flexible"}
          className={className}
        />
        {error &&
            <div>
                <span className='d-flex align-items-center my-2'>
                    <i className="fa fa-exclamation-circle errorIcon" />
                    <p className="errorText mb-0 ml-0">Captcha is Required</p>
                </span>
            </div>
        }
    </>
  );
}